import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'

import {trans} from '@utils'

import Statistic from "../Statistic"

const StatisticIssuesCount = props => {
  const {
    initOnMount = false,
    uri = null,
    withChart = true,
    chartType = 'area',
    vertical = false,
    height = 100,
    skeletonMinHeight
  } = props
  const {value, loading, stats} = useSelector(store => _.get(store, 'analytics.data.statistics_issues_count'))

  const dispatch = useDispatch()

  useEffect(() => {
    if (initOnMount) {
      // _getAverageScore(uri)
    }
    return () => {
      // dispatch({
      //   type: 'ANALYTICS_CHARTS_DATA',
      //   payload: {
      //     total_deficiencies: {
      //       value: 0,
      //       loading: true,
      //       stats: []
      //     }
      //   }
      // })
    }
  }, [])

  return (
    <Statistic
      title={trans('analytics.actions.inspectionIssues')}
      color={'info'}
      data={stats}
      stats={value}
      // icon={<User />}
      withChart={withChart}
      chartType={chartType}
      vertical={vertical}
      loading={loading}
      height={height}
      skeletonMinHeight={skeletonMinHeight}
    />
  )
}

StatisticIssuesCount.propTypes = {}

export default StatisticIssuesCount
